import React from "react";

interface ResourcesHeroProps {
    activeTab: "videos" | "books";
    setActiveTab: (tab: "videos" | "books") => void;
}

const ResourcesHero: React.FC<ResourcesHeroProps> = ({
    activeTab,
    setActiveTab,
}) => {
    return (
        <div className="bg-darkerGrey py-16 text-center text-white">
            <div className="container mx-auto px-4">
                <p className="mb-4 text-xl font-medium uppercase tracking-wider text-mustardYellow">
                    Resources
                </p>
                <h1 className="mb-4 text-3xl font-bold md:text-5xl">Resource library</h1>
                <p className="mb-8 text-lg font-light text-gray-300">
                    Books and Video lessons to help you in your consistent Bible Reading
                    Journey
                </p>

                <div className="flex justify-center">
                    <div className="inline-flex gap-2 p-1.5 rounded-lg bg-white/10 border border-white/20 shadow-inner">
                        <button
                            onClick={() => setActiveTab("videos")}
                            className={`rounded px-6 py-2 text-sm font-medium transition-all duration-200 ${activeTab === "videos"
                                ? "bg-white text-darkerGrey border-2 border-mustardYellow shadow-lg"
                                : "text-white border-2 border-transparent hover:text-gray-300 hover:bg-white/5"
                                }`}
                        >
                            Video Lessons
                        </button>
                        <button
                            onClick={() => setActiveTab("books")}
                            className={`rounded px-6 py-2 text-sm font-medium transition-all duration-200 ${activeTab === "books"
                                ? "bg-white text-darkerGrey border-2 border-mustardYellow shadow-lg"
                                : "text-white border-2 border-transparent hover:text-gray-300 hover:bg-white/5"
                                }`}
                        >
                            Books
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResourcesHero;
